import React from 'react';
import AudioVisualizer from './AudioVisualizer';

class AudioAnalyzer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioData: new Uint8Array(0),
    };
  }

  componentDidMount() {
    const { audio } = this.props;

    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    console.log('this.audioContext: ', this.audioContext);
    this.analyser = this.audioContext.createAnalyser();
    this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
    this.source = this.audioContext.createMediaStreamSource(audio);
    this.source.connect(this.analyser);
    this.rafId = requestAnimationFrame(this.tick);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.rafId);
    this.analyser.disconnect();
    this.source.disconnect();
  }

  tick = () => {
    this.analyser.getByteTimeDomainData(this.dataArray);
    this.setState({ audioData: this.dataArray });
    this.rafId = requestAnimationFrame(this.tick);
  };

  render() {
    const { audioData } = this.state;

    return <AudioVisualizer audioData={audioData} />;
  }
}

export default AudioAnalyzer;
